import { gql } from '@apollo/client';

export default gql`
  mutation ProjectInvitationCreate($input: ProjectInvitationCreateInput!) {
    projectInvitationCreate(input: $input) {
      acceptanceUrl
      newProjectInvitationEdge {
        node {
          databaseId
          id
          project {
            id
            formattedLine1
            company {
              id
              name
            }
          }
        }
      }
      errors {
        error
        message
      }
    }
  }
`;
